import React from "react";
import './LoadingPageCSS.css';
export const LoadingPage = () => {
    return <div className="loader"></div>
}